import { formatDate } from "../../../utils";
import { formatExtendedPtBr } from "utils/document-utils";

export async function generatePrintNpsTrialHtml(processes, config) {

    const rowsHtml = (Array.isArray(processes) ? processes : [])
        .map((p) => {
        const numero = p?.numero ?? "";
        const requerente =
            p?.trafficViolation?.vehicle?.nome_proprietario ??
            p?.infracao?.nome_proprietario_veiculo_ait ??
            p?.infracao?.nome_proprietario_veiculo_penalidade ??
            p?.infracao?.nome_condutor ??
            "";
        const numeroAit =
            p?.trafficViolation?.numero_ait ??
            p?.infracao?.numero_ait ??
            "";
        const cod = (
            (p?.trafficViolation?.codigo_tipo_infracao ??
            p?.infracao?.codigo_tipo_infracao ??
            "") +
            "-" +
            (p?.trafficViolation?.desdobramento_tipo_infracao ??
            p?.infracao?.desdobramento_tipo_infracao ??
            "")
        ).replace(/-$/, "");

        const resultado =
            (typeof p?.getReporterDecision === "function" && p.getReporterDecision()) ||
            p?.decisao_relator ||
            p?.decisao ||
            p?.decisao_final ||
            "";

        return `
            <tr>
            <td class="text-center">${numero}</td>
            <td>${requerente}</td>
            <td class="text-center">${numeroAit}</td>
            <td class="text-center">${cod}</td>
            <td class="text-center">${resultado}</td>
            </tr>
        `;
        })
        .join("");
    
    const meetingDateLong = formatExtendedPtBr(processes[0].data_limite_julgamento);

    const dept_description = processes[0].unidade_administrativa_responsavel.descricao;

    const dept_sig = processes[0].unidade_administrativa_responsavel.sigla;

    return `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <link rel="icon" type="image/png" href="/assets/logos/logo.png" />
      <head>
        <meta charset="UTF-8">
        <title>GOTT - Gestor de Operações de Transito e Transporte</title>
        <style>
          body {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            background-color: #fff;
            margin: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 4px;
          }
          td {
            border: 1px solid black;
            padding: 2px;
            vertical-align: top;
            line-height: 1.42857143;
            width: 33.33333333%;
          }
          small {
            margin-top: 1px;
            display: block;
            font-size: 7pt;
            line-height: 8px;
          }
          strong {
            font-weight: bold !important;
          }
          p {
            margin: 0 !important;
          }
          h1 {
            font-weight: 500;
            line-height: 1.1;
            margin: 0.67em 0;
          }
          h4 {
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 18px;
            line-height: 1.1;
            font-weight: 500;
          }
          .text-center {
            text-align: center;
          }
          .highlighted {
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            margin: 5px 0;
            text-decoration: underline;
            text-transform: uppercase;
          }
          .head-text {
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            padding: 0 15px;
          }
          .image-container {
            padding-left: 15px;
            padding-right: 15px;
            min-height: 1px;
          }
          .align-middle {
            vertical-align: middle !important;
          }
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
            }
            header, footer {
              display: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="cape" style="max-width: 800px; margin: 16px">
            <div class="text-center">
                ${config?.company_owner_logo ? `<img src="/assets/logos/${config?.company_owner_logo}" width="200"><br><br>` : ""}
                <strong>${config?.company_state_description}</strong><br>
                <strong>${config?.company_owner_name}</strong><br>
                <strong>${config?.company_name}</strong><br>
                <strong>${dept_description.toUpperCase()} - ${dept_sig}</strong>

                <br>
                <br>

                <strong>PROTOCOLO DE ENTREGA DE PROCESSOS PARA RELATO E JULGAMENTO</strong>
            </div>

            <br>
            <br>

            <div class="text-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Certifico para os devidos fins que foram entregues os autos dos processos abaixo listados ao <strong>${config?.chief_full_name}</strong> para submetê-los a julgamento na reunião que será realizada no dia <strong><u>${meetingDateLong}</u></strong>.
            </div>

            <br>

            <table class="table table-bordered" style="width:100%; border-collapse:collapse;">
                <tr>
                <th class="col-sm-1 text-center">Processo</th>
                <th class="col-sm-3 text-center">Requerente</th>
                <th class="col-sm-1 text-center">Número AIT</th>
                <th class="col-sm-1 text-center">Código</th>
                <th class="col-sm-2 text-center">Resultado</th>

                ${rowsHtml}
                </tr>
            </table>

            <br>
            <br>

            <div class="text-center">
                <strong>Recebi em ____________________________________</strong>

                <br>
                <br>
                <br>
                <br>

                <strong>${config.chief_full_name} - Presidente - ${dept_sig}</strong>
            </div>
            </div>
      </body>
      </html>
  `;
}
